/**
 * Usage
 * import Env from "@/constants/environment"
 *
 * if (Env.isDevelopment) {
 *     console.log("running in development mode...")
 * }
 */

interface Environment {
  isDevelopment: boolean
  isStaging: boolean
  isProduction: boolean
  toString: () => string
}

// NOTE(spk): import.meta.env.MODE is initialized by Vite and can be set with the --mode flag
// ex: npm run dev -- --mode=staging
const DevMode = "development"
const StagingMode = "staging"
const ProdutionMode = "production"

const Env: Environment = {
  isDevelopment: import.meta.env.MODE === DevMode,
  isStaging: import.meta.env.MODE === StagingMode,
  isProduction: import.meta.env.MODE === ProdutionMode,
  toString: () => import.meta.env.MODE,
}

export default Env
